import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: 'NAVIGATION',
    main: [
      //{
        //state: 'dashboard',
        //short_label: 'D',
        //name: 'Home',
        //type: 'link',
        //icon: 'ti-home',
        //children: [
        //  {
        //    state: 'dashboard',
        //    name: 'Default'
        //  }/*,
        //  {
        //    state: 'ecommerce',
        //    name: 'Ecommerce'
        //  },
        //  {
        //    state: 'analytics',
        //    name: 'Analytics',
        //    badge: [
        //      {
        //        type: 'info',
        //        value: 'NEW'
        //      }
        //    ]
        //  }*/
        //]
    //  },

      {
        state: 'registrations',
        short_label: 'R',
        name: 'Registrations',
        type: 'link',
        icon: 'fa fa-tags'
      },


      //{
      //  state: 'profile',
      //  short_label: 'P',
      //  name: 'My Profile',
      //  type: 'link',
      //  icon: 'ti-user'
      //} ,


      {
        state: 'registration',
        short_label: 'R',
        name: 'New Registration',
        type: 'link',
        icon: 'ti-plus'
      }


    ]
  }
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }
}
